import { DataSource } from '@angular/cdk/collections';
import { AdminGuardService } from './../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, DoCheck } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog, MatSidenavModule, MatTooltipModule} from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { AuthService } from '../../servicios/auth.service';
import { UserGuardService } from '../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../servicios/guards/multi-user.service';
import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { read } from 'cfb/types';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';

//ngx-webcam 1
import {Subject} from 'rxjs';
import {Observable} from 'rxjs';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import { environment } from "environments/environment";
import { GLOBALService } from "../../servicios/functions/GLOBAL.service";

//material1
export interface DatosGrid {
  id: string;
  id_usuario: string;
  observacion: string;
  fecha_movimiento: string;
  categoria: string;
}


@Component({
  selector: 'app-nuevofondofijo',
  templateUrl: './nuevofondofijo.component.html',
  styleUrls: ['./nuevofondofijo.component.css']
})
export class NuevofondofijoComponent implements OnInit {
 //material3
  displayedColumns: string[] = ['id', 'id_usuario', 'observacion', 'fecha_movimiento', 'categoria'];
  dataSourceGrid = new MatTableDataSource<DatosGrid>();
 //dataSource = new MatTableDataSource(ELEMENT_DATA);
 @ViewChild(MatPaginator, {}) paginator: MatPaginator;
 @ViewChild(MatSort, {}) sort: MatSort;


 @ViewChild('REPORTE') reporte: ElementRef;
  filtroSec;
  descsec;
  importe;
  loading;
  dataSourceSec;
  contGrid;
  ;
  
  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private global: GLOBALService
  ) { 
     this.loading=false;
    }

  ngOnInit() {
    this.llenarComboSec()
    this.getFondo();
    //this.importe=550;
  }

  ngDoCheck(){
    console.log("SEC: " + this.filtroSec);
    console.log("IMP: $" + this.importe);
    console.log("DESC: "+ this.descsec);
    this.contGrid = this.dataSourceGrid.data.length
  }

  applyFilter(filterValue: string) {
    this.dataSourceGrid.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceGrid.paginator) {
      this.dataSourceGrid.paginator.firstPage();
    }
  }

  llenarComboSec(){
    this.loading=true;
    //http://localhost:1337/api/getseccionales/getfondo
    this.http.get(`${environment.backendUrl}/api/getseccionales/getfondo`)
    .subscribe((datos: any[]) => {
      if (datos){
        console.log("se llena el combo de seccionales.");
        this.dataSourceSec = datos[0];
        console.warn(this.dataSourceSec);
        this.loading=false;
      }else{
        console.log("no hay datos de sec..");
        this.loading=false;
      }
    });
  }
 result;
 
  updateFondoFijo(){
    //http://localhost:1337/api/updatefondofijo/change?idsec=03&impo=500
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/updatefondofijo/change?idsec=${this.filtroSec}&impo=${this.importe}`)
      .subscribe((data: any) => {
        this.result = JSON.stringify(data["affectedRows"]);
        if (this.result>0){
          console.log(`Fondo fijo modificado!!`);
          this.snackBar.open(`Fondo Fijo Modifijado OK!!`, 'Cerrar', {duration: 4000});
          if (this.importe>0){
            this.global.historicalTo("FONDO FIJO / A SEC/DEL: [" + this.descsec +"], det: *AÑADE* IMPORTE: $" + this.importe + ", a las: " + this.global.horario(),'FONDO-FIJO');
          }else{
            this.global.historicalTo("FONDO FIJO / A SEC/DEL: [" + this.descsec +"], det: *DESCUENTA* IMPORTE: $" + this.importe + ", a las: " + this.global.horario(),'FONDO-FIJO');
          }
          
          this.loading=false;
          this.llenarComboSec();
          this.getFondo();
          this.limpiar();

        }else{
          console.log(`no se modifico el fondo fijo!`);
        }
    });
  }
  
  getFondo(){
    //http://localhost:1337/api/gethistorico/get?user=TODOS_LOS_USUARIOS&ca=FONDO-FIJO
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/gethistorico/get?user=TODOS_LOS_USUARIOS&ca=FONDO-FIJO`)
    .subscribe((datos: any[]) => {
      if (datos){
        console.log("calculando historico de fondo fijo.");
        this.dataSourceGrid.data = datos[0];
        console.log(this.dataSourceGrid.data);
        this.loading=false;
      }else{
        console.log("no hay historico de fondo fijo.");
        this.loading=false;
      }
    });
  }

  limpiar(){
    this.filtroSec=null;
    this.importe=null;
  }

  dataSourceFondo;
  calcularSec(id){
    //http://localhost:1337/api/getseccionales/getid?idsec=03
    //console.log("*******FONDO**");
    this.descsec = 0;
     this.http.get(`${environment.backendUrl}/api/getseccionales/getid?idsec=${id}`)
     .subscribe((data: any) => {
        this.dataSourceFondo = data;
        this.descsec = this.dataSourceFondo[0]["descripcion"];
        //console.warn(this.descsec);
     });
  
  }
  
}
